import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { apiInstance } from '../../axiosApi';

export const companyListGet = createAsyncThunk('admin/companies', async (params) => {
  return await apiInstance.get('/companies', { params });
});

export const companyDelete = createAsyncThunk('admin/companies-delete', async (id) => {
  return await apiInstance.delete(`/companies/${id}`);
});

export const companyAdd = createAsyncThunk('admin/companies-add', async (payload) => {
  return await apiInstance.post('/companies', payload);
});

export const companyUpdate = createAsyncThunk('admin/companies-update', async (payload) => {
  const { id, ...rest } = payload;
  return await apiInstance.put(`/companies/${id}`, rest);
});

const initialState = {
  companyList: null
};

const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    clearCompanySlice: () => initialState
  },
  extraReducers: (builder) => {
    builder.addCase(companyListGet.fulfilled, (state, action) => {
      state.companyList = action?.payload;
    });
  }
});

export default companySlice.reducer;
export const { clearCompanySlice } = companySlice.actions;

export const selectCompanyList = (state) => state.company.companyList;
export const useCompanyList = () => {
  const companyList = useSelector(selectCompanyList);
  return useMemo(() => companyList, [companyList]);
};
